
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'MaMA Music & Convention',
    appTitle: 'MaMA Music et Convention',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/mama-2024/id1287534417',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=com.greencopper.mamaevent&hl=ln&pli=1',
    appIconUrl: 'https://static.mama.chapi.to/app-icon.jpeg',
  }
